module.exports = __webpack_public_path__ + "static/graph-year-3-b2b212f630dfba21471061d625f0b192.svg";